<script setup>
import { defineProps, ref } from 'vue';
import ProductListWithBooking from "@/components/frontend/booking/ProductListWithBooking.vue";
import ProductStageAvailability from "@/components/frontend/booking/ProductStageAvailability.vue";


const props = defineProps({
  stage: {
    required: true,
  },
  availableFilters: {
    type: Object,
    default: function() {
      return {};
    }
  },
  urlProducts: {
    required: true
  },
  urlAvailability: {
    required: true,
  },
  urlBooking: {
    required: true,
  },
  urlRegistration: {
    required: true,
    type: String,
  },
  minDate: {
    type: String,
    required: true
  },
  maxDate: {
    type: String,
  },
  lifetimeInMinutes: {
    type: Number,
    default: 15,
  },
});

const productHasSlotAvailable = (product) => {
  return true
  return product.combinations.some(item => item.available);
}

</script>

<template>
  <ProductListWithBooking
    :url-products="urlProducts"
    :url-booking="urlBooking"
    :url-registration="urlRegistration"
    :lifetime-in-minutes="lifetimeInMinutes"
    :available-filters="availableFilters"
    :isAvailable="productHasSlotAvailable"
    :base-filters="{
      stage_id: stage.id
    }"
  >
    <template #bookingModal="{product, onBookingSubmited}">
      <ProductStageAvailability
        v-if="product"
        :url-availability="urlAvailability"
        :product="product"
        :stage="stage"
        @submitBooking="onBookingSubmited($event)"
      ></ProductStageAvailability>
    </template>

  </ProductListWithBooking>
</template>